/*!

=========================================================
* Material Kit PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import { Link as RouerLink } from "react-router-dom";
import Link from '@material-ui/core/Link';
import { helper } from "../../../assets/js/utils/Element";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import CameraIcon from "@material-ui/icons/CameraAlt";
// core components
import headerStyle from "../../../assets/jss/material-kit-pro-react/components/headerStyle.jsx";
import logo from "../../../assets/img/logo.png";
import responsiveLogo from "../../../assets/img/logo.png";
import Popover from '@material-ui/core/Popover';
import ChartistGraph from "react-chartist";
import CustomFileInput from "../CustomFileInput/CustomFileInput";
import LoaderComponent from '../../components/Loader'
import DeleteIcon from "@material-ui/icons/DeleteSharp";
import Config from "../../../../Config";
import moment from 'moment';
import Switch from "@material-ui/core/Switch";
import Button from "../CustomButtons/Button.jsx";
import { Link as RouterLink } from "react-router-dom";
import FirstTimeLoginModal from "../User/FirstTimeLoginModal.jsx";
import ConfirmationModal from '../User/ConfirmationModal';

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.store = this.props.store;
        this.history = this.props.history;
        const { user } = this.store.getState();
        this.state = {            
            mobileOpen: this.props.open,
            color: this.props.color,
            isResponsive: this.props.isResponsive,
            popupOpen: false,
            anchorEl: null,
            supportPopupOpen: false,
            supportAnchorEl: null,
            photo: null,
            success: false,
            uploading: false,
            user: user,
            firstTimeLoginModal: false,
            firstTimeloginData: this.getFirstTimeLoginData(),
            newUser: null,
            activateSaving: false,
            subscriptionModal: false,
            subscriptionUserData: null,
            showSubscriptionError: false
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.headerColorChange = this.headerColorChange.bind(this);
        this.handlePopup = this.handlePopup.bind(this);
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    handlePopup(){
        this.setState({ popupOpen: !this.state.popupOpen });
    }
    componentWillReceiveProps(props){
        const { user, authorized } = this.store.getState();
        let state = {
            color: props.color,
            mobileOpen: props.open,
            isResponsive: props.isResponsive
        };
        if(this.state.user.email === '' && user.id !== ''){
            state['user'] = user;
            state['firstTimeloginData'] = this.getFirstTimeLoginData();
        }
        
        this.setState(state,() => {
            if(authorized && user.login === 0){
                this.onFirstTimeLoginModal(true);
                this.updateLoginStatus();
            }
        });
        if (this.props.changeColorOnScroll) {
            const that = this;
            setTimeout(function(){ that.headerColorChange(); },100);
        }
    }
    componentDidMount() {        
        if (this.props.changeColorOnScroll) {
            window.addEventListener("scroll", this.headerColorChange);
            this.headerColorChange();
        }
    }
    headerColorChange() {
        const { color, changeColorOnScroll } = this.props;
        const windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            this.setState({color: changeColorOnScroll.color});
        } else {
            this.setState({color: color});
        }
    }
    componentWillUnmount() {
        if (this.props.changeColorOnScroll) {
            window.removeEventListener("scroll", this.headerColorChange);
        }
    }
    getUserTitle(user){
        let title = "";
        if(user.hasOwnProperty("first_name")){
            title += user.first_name;
        }
        if(user.hasOwnProperty("last_name")){
            title += " "+user.last_name;
        }
        return title;
    }
    handleClick = (event) => {
        this.setState({
            popupOpen: true,
            anchorEl: event.currentTarget
        });

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 200);
    };
    handleSupportClick = (event) => {
        this.setState({
            supportPopupOpen: true,
            supportAnchorEl: event.currentTarget
        });

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 200);
    }
    handleFileChange(e, name){
        let photo = e.target.files[0];

        var requestData = new FormData();
        requestData.append('photo', photo);

        const source = axios.CancelToken.source();
        this.setState({
            [name]: photo,
            uploading: true,
            cancelToken: source,
            showError: false,
        });

        const that = this;
        Api.uploadUserPhoto(requestData, source).then(data => {
            that.setState({
                success: true,
                uploading: false
            });
            let newUser = Api.prepareMemberObject(data);
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    uploading: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    removeProfilePhoto(e, name){
        var requestData = {};

        const source = axios.CancelToken.source();
        this.setState({
            [name]: '',
            uploading: true,
            cancelToken: source,
            showError: false,
        });

        const that = this;
        Api.removeUserPhoto(requestData, source).then(data => {
            that.setState({
                success: false,
                uploading: false
            });
            let newUser = Api.prepareMemberObject(data);
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    uploading: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    handleClose = () => {
        this.setState({
            popupOpen: false,
            anchorEl: null
        })
    }
    handleSupportClose = () => {
        this.setState({
            supportPopupOpen: false,
            supportAnchorEl: null
        })
    }
    renderStats(){
        const { user } = this.store.getState();
        if(!user.hasOwnProperty("stats")){
            return <></>
        }
        let stats = [];
        user.stats.map((stat, key) => {
            const statClassName = stat.title.toLowerCase().replace(" ","_");
            stats.push((
                <li key={key}>
                    <ul>
                        <li className="stat-name"><span className={statClassName}></span> {stat.title}</li>
                        <li className="stat-perc">{stat.storage_used}%</li>
                    </ul>
                </li>
            ));
            return null;
        });
        return stats;
    }
    getPieChart(){
        const { user } = this.store.getState();
        const quota = user.quota;
        const usage = user.usage;
        let usagePercentage = (usage/quota)*100;
        usagePercentage = Math.round(usagePercentage * 10) / 10;
        if(usagePercentage > 100){
            usagePercentage = 100;
        }
        let remainingPercentage = 100 - usagePercentage;
        if(remainingPercentage < -100){
            remainingPercentage = -100;
        }
        if(helper.isFloat(usagePercentage)){
            usagePercentage = usagePercentage.toFixed(1);
        }
        if(helper.isFloat(remainingPercentage)){
            remainingPercentage = remainingPercentage.toFixed(1);
        }
        let pieChart = {
            data: {
                labels: [usagePercentage+"%", remainingPercentage+"%"],
                series: [usagePercentage, remainingPercentage]
            },
            options: {
                chartPadding: 0,
                height: 67,
                width: 67
            }
        };
        return pieChart;
    }
    getLogo(){
        const { user } = this.store.getState();
        const { isResponsive } = this.props;

        if(user.hasOwnProperty('businessUser') && user.businessUser !== null && user.businessUser.profile_photo_url !== ''){
            return user.businessUser.profile_photo_url
        }else{
            return isResponsive ? responsiveLogo : logo
        }
    }
    renderScheduled(){
        const { authorized, user } = this.store.getState();
        if(!authorized){
            return null;
        }
        if(!user.hasOwnProperty("scheduled_deletion") || !user.scheduled_deletion 
        || !user.hasOwnProperty("scheduled_deletion_at") || !user.scheduled_deletion_at || user.scheduled_deletion_at.length <= 0){
            return null;
        }
        const { classes } = this.props;
        const deletionDate = moment(user.scheduled_deletion_at);
        const currentDate = moment(new Date());
        const duration = moment.duration(deletionDate.diff(currentDate));
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        return (
            <span className={classes.scheduledDeletion}>
                Your account is in the process of being deleted in{" "}
                {
                    days > 0 ?
                        days > 1 ? (days+" days") : (days+" day")
                    :
                        hours > 0 ?
                            hours > 1 ? (hours+" hours") : (hours+" hour")
                        :
                            minutes > 1 ? (minutes+" minutes") : (minutes+" minute")
                }
            </span>
        )
    }
    handleThemeToggle(e, name){  
        this.setState({
            user: {
                ...this.state.user,
                [name]: e.target.checked ? 'standard' : 'light'
            }
        },() => {
            this.updateUserSettings()
        });
    }
    updateUserSettings(){
        const source = axios.CancelToken.source();
        const { user } = this.state;
        const requestData = {
            theme: user.theme
        }
        
        Api.updateUserSettings(requestData, source).then(data => {
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.body));
            let newUser = Api.prepareMemberObject(data.body);
            this.store.dispatch({type: "UPDATE_STATE",state: {user: newUser}});
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({cancelToken: null, saving: false});
            }  
        });
    }
    updateLoginStatus(){
        const values = {}
        const source = axios.CancelToken.source();
        Api.updateLoginStatus(values, source).then((data) => {
            let newUser = Api.prepareMemberObject(data.user);
            this.setState({
                newUser: newUser
            })
        }).catch(err => {
            this.setState({
                savingInfo: false, 
                showError: true, 
                errorMessage: err.message
            });
        });
    }
    onFirstTimeLoginModal(modal = true){
        this.setState({
            firstTimeLoginModal: modal,
        });

        if(this.state.newUser !== null){
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(this.state.newUser));
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: this.state.newUser}});
        }
        this.handleSupportClose();
    }
    getFirstTimeLoginData(){
        const { user, authorized } = this.store.getState();
        
        let firstTimeloginData = null;
        if(authorized){
            if(user.loginVideos.length > 0){
                user.loginVideos.map(video => {
                    if(user.level_id === 5){
                        if(video.type === 5){
                            firstTimeloginData = video;
                        }
                    }else{
                        if((user.account_type === 1 || user.account_type === 2) && video.type === 2){
                            firstTimeloginData = video;
                        }else if(user.account_type === 3 && video.type === 3){
                            firstTimeloginData = video;
                        }else if(user.account_type === 4 && video.type === 4){
                            firstTimeloginData = video;
                        }else if(user.account_type === 6 && video.type === 6){
                            firstTimeloginData = video;
                        }
                    }
                    return null;
                });
            }
        }

        return firstTimeloginData;
    }
    dismissRecoveryOption(){
        const { user } = this.store.getState();
        let values = Api.prepareMemberObject(user);
        values = Object.assign({}, values);
        values.dismiss_recovery_section = 1;
        values.skipValidation = 1;

        const source = axios.CancelToken.source();
        Api.updateUser(user.id, values, source).then((data) => {
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            let newUser = Api.prepareMemberObject(data.user);
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            this.setState({
                showError: true, 
                errorMessage: err.message
            });
        });
    }
    onSubscriptionModal(status = false){
        this.setState({
            subscriptionModal: status,
            showSubscriptionError: false,
            errorMessage: ''
        });

        if(this.state.subscriptionUserData !== null){
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(this.state.subscriptionUserData));
            let newUser = Api.prepareMemberObject(this.state.subscriptionUserData);

            this.setState({
                subscriptionUserData: null,
            })
            
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }
    }
    subscriptionTrialEnd(){
        this.setState({
            activateSaving: true,
        })

        const source = axios.CancelToken.source();
        Api.subscriptionTrialEnd({}, source).then((data) => {
            this.setState({
                activateSaving: false,
                subscriptionUserData: data.user,
            });
            // localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            // let newUser = Api.prepareMemberObject(data.user);
            // this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            this.setState({
                showSubscriptionError: true,
                errorMessage: err.message,
                activateSaving: false
            });
        });
    }
    getVerifyUrl(){
        const { user } = this.store.getState();
        if(user.hasOwnProperty('basic_info_filled') && !user.basic_info_filled){
            return "/user/profile";
        }

        return "/user/security";
    }
    render() {
        const { classes, mobileLinks, links, brand, fixed, absolute } = this.props;
        const { authorized, user, url } = this.store.getState();
        const { color, popupOpen, anchorEl, photo, uploading, success, supportPopupOpen, supportAnchorEl, firstTimeLoginModal, 
            showSubscriptionError, errorMessage, firstTimeloginData, activateSaving, subscriptionModal, subscriptionUserData } = this.state;

        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes[color]]: color,
            [classes.absolute]: absolute,
            [classes.fixed]: fixed
        });
        
        let userFirstLetter = user.first_name.charAt(0);
        const pieChart = this.getPieChart();
        const id = popupOpen ? 'simple-popover' : undefined;
        const supportId = supportPopupOpen ? 'simple-popover' : undefined;
        return (
            <AppBar className={appBarClasses+" "+(helper.showSidebar(url, user, authorized) ? 'show-sidebar': '')}>
                <Toolbar className={classes.container}>
                    {
                        helper.showSidebar(url, user, authorized) ?
                            <RouerLink to={(authorized ? helper.getHomePageUrl(user) : "/")} className={classes.brand+" mobile-logo"}>
                                <img src={this.getLogo()} alt={brand} />
                            </RouerLink>
                        :
                            <RouerLink to={(authorized ? helper.getHomePageUrl(user) : "/")} className={classes.brand}>
                                <img src={this.getLogo()} alt={brand} />
                            </RouerLink>
                    }
                    <div className={classes.headerIconSection}>
                        {/* {this.renderScheduled()} */}
                        {
                            authorized ?
                                <>
                                    <Hidden smDown implementation="css" className={classes.hidden}>
                                        <div className={classes.collapse}>{links}</div>
                                    </Hidden>
                                    <div className={classes.activateMenu}>
                                        {
                                            activateSaving ?
                                                <LoaderComponent color="custom" align="left" size={20} /> 
                                            : user.hasOwnProperty('is_subscription_on_trial') && user.is_subscription_on_trial ?
                                                <Button simple onClick={() => this.onSubscriptionModal(true)} className={classes.dropdownLink}>
                                                    Activate
                                                </Button>
                                            : user.hasOwnProperty('is_verified') && !user.is_verified ?
                                                <RouterLink to={this.getVerifyUrl()} className={classes.dropdownLink}>
                                                    Verify
                                                </RouterLink>
                                            :
                                                null
                                        }
                                    </div>
                                    <div className={classes.switchLayoutIcon} title="Theme Layout">
                                        <Switch
                                            checked={(this.state.user.theme === 'standard' ? true : false)}
                                            onChange={(e) => this.handleThemeToggle(e, 'theme')}
                                            value="theme"
                                            classes={{
                                                switchBase: classes.switchBase,
                                                checked: classes.switchChecked,
                                                thumb: classes.switchIcon,
                                                track: classes.switchBar
                                            }}
                                        />
                                    </div>
                                    <>
                                        <div className={classes.supportIcon} 
                                            aria-label="open popup"
                                            variant="contained"
                                            onClick={this.handleSupportClick}
                                            aria-describedby={supportId}
                                            title="Support"
                                        >
                                            <svg width="12" height="18" viewBox="0 0 12 18" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.33333 1.30909C3.125 1.30909 1.33333 3.06818 1.33333 5.23636C1.33333 5.59636 1.03333 5.89091 0.666667 5.89091C0.3 5.89091 0 5.59636 0 5.23636C0 2.34409 2.3875 0 5.33333 0H6.66667C9.6125 0 12 2.34409 12 5.23636C12 6.68045 11.3083 8.03454 10.1333 8.90182L7.6 10.7673C7.0125 11.2009 6.66667 11.88 6.66667 12.6V13.0909C6.66667 13.4509 6.36667 13.7455 6 13.7455C5.63333 13.7455 5.33333 13.4509 5.33333 13.0909V12.6C5.33333 11.4668 5.875 10.3991 6.8 9.72L9.33333 7.85455C10.1708 7.23682 10.6667 6.26727 10.6667 5.23636C10.6667 3.06818 8.875 1.30909 6.66667 1.30909H5.33333ZM5 17.0182C5 16.7578 5.10536 16.5081 5.29289 16.3239C5.48043 16.1398 5.73478 16.0364 6 16.0364C6.26522 16.0364 6.51957 16.1398 6.70711 16.3239C6.89464 16.5081 7 16.7578 7 17.0182C7 17.2786 6.89464 17.5283 6.70711 17.7124C6.51957 17.8966 6.26522 18 6 18C5.73478 18 5.48043 17.8966 5.29289 17.7124C5.10536 17.5283 5 17.2786 5 17.0182Z" />
                                            </svg>
                                        </div>
                                        <Popover
                                            id={supportId}
                                            open={supportPopupOpen}
                                            anchorEl={supportAnchorEl}
                                            onClose={this.handleSupportClose}
                                            keepMounted
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 40,
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            classes={{
                                                root: classes.supportPopoverRoot
                                            }}
                                        >
                                            <div className={classes.supportPopupContent}>
                                                <ul>
                                                    {
                                                        firstTimeloginData !== null ?
                                                            <li>
                                                                <Button color="transparent" onClick={() => this.onFirstTimeLoginModal(true)} className={"support-link"}>
                                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9.67555 2.30148L9.64274 2.06655C9.56072 1.48338 9.10686 1.02458 8.52996 0.941661L8.29756 0.908495C8.0597 0.875329 7.89292 0.648693 7.92573 0.408237C7.95854 0.167782 8.18 -0.00357722 8.4206 0.0323529L8.653 0.0655192C9.6154 0.203712 10.3727 0.9693 10.5094 1.94218L10.5423 2.1771C10.5751 2.41756 10.411 2.6442 10.1704 2.67736C9.92982 2.71053 9.70836 2.5447 9.67555 2.30148ZM5.11508 1.97811C4.77332 1.63263 4.77332 1.07156 5.11508 0.726081C5.45684 0.380599 6.01186 0.380599 6.35362 0.726081L11.6031 6.03268C11.6933 6.12389 11.8601 6.06309 11.8601 5.93042V3.7829C11.8601 3.17209 12.3495 2.67736 12.9537 2.67736C13.558 2.67736 14.0474 3.17209 14.0474 3.7829V8.65835C14.0474 10.3222 13.2846 11.8893 11.9831 12.9064C10.5915 13.9926 8.82251 14.28 7.23674 13.8102C6.46025 13.6139 5.72478 13.2077 5.11508 12.5913L4.98111 12.4559L2.05289 9.49579L1.17798 8.61136C0.836222 8.26588 0.836222 7.70482 1.17798 7.35933C1.51975 7.01385 2.07477 7.01385 2.41653 7.35933L3.2887 8.241L3.29144 8.24377L4.56553 9.53449C4.7077 9.67821 4.93736 9.67821 5.0768 9.53449C5.21624 9.39077 5.21897 9.1586 5.0768 9.01765L1.61544 5.51584C1.27368 5.17036 1.27368 4.6093 1.61544 4.26382C1.9572 3.91833 2.51222 3.91833 2.85398 4.26382L6.31535 7.76562C6.45752 7.90934 6.68718 7.90934 6.82662 7.76562C6.96606 7.6219 6.96879 7.38974 6.82662 7.24878L2.9278 3.30476C2.58604 2.95928 2.58604 2.39821 2.9278 2.05273C3.26957 1.70725 3.82459 1.70725 4.16635 2.05273L8.06517 5.99675C8.20734 6.14047 8.437 6.14047 8.57644 5.99675C8.71588 5.85303 8.71861 5.62087 8.57644 5.47991L5.11508 1.97811ZM0.423374 9.76112C0.42312 9.76112 0.423106 9.76076 0.423358 9.76072C0.660211 9.72648 0.882826 9.89472 0.915511 10.137L0.94832 10.3719C1.03034 10.9551 1.4842 11.4139 2.0611 11.4968L2.29349 11.53C2.53136 11.5632 2.69814 11.7898 2.66533 12.0302C2.63252 12.2707 2.40833 12.4393 2.17046 12.4061L1.93806 12.373C0.975661 12.2348 0.218317 11.4692 0.0816119 10.4963L0.0515368 10.2614C0.0187277 10.0209 0.182773 9.79429 0.423374 9.76112Z" fill="#FAAF42"/>
                                                                    </svg>
                                                                    <span className="label">Welcome</span>
                                                                </Button>
                                                            </li>
                                                        :
                                                            <></>
                                                    }
                                                    <li>
                                                        <RouterLink to="/user/support" onClick={this.handleSupportClose} className={"support-link"}>
                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM3.5 5.25C3.5 4.76602 3.89102 4.375 4.375 4.375H9.625C10.109 4.375 10.5 4.76602 10.5 5.25V5.5043L7.23789 6.98906C7.16406 7.02188 7.08203 7.04102 7 7.04102C6.91797 7.04102 6.83867 7.02461 6.76211 6.98906L3.5 5.5043V5.25ZM7.59883 7.78477L10.5 6.4668V8.75C10.5 9.23398 10.109 9.625 9.625 9.625H4.375C3.89102 9.625 3.5 9.23398 3.5 8.75V6.4668L6.40117 7.7875C6.58984 7.87227 6.79219 7.91875 7 7.91875C7.20781 7.91875 7.41016 7.875 7.59883 7.7875V7.78477Z" fill="#FAAF42"/>
                                                            </svg>
                                                            <span className="label">Support</span>
                                                        </RouterLink>
                                                    </li>
                                                    {
                                                        user.settings.tutorialsMenuUrl !== '' ?
                                                            <li>
                                                                <Link href={user.settings.tutorialsMenuUrl} target="_blank" className={"support-link"}>
                                                                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M0 1.75C0 0.784766 0.807187 0 1.8 0H14.4C15.3928 0 16.2 0.784766 16.2 1.75V5.775C15.6516 5.50156 15.0441 5.32656 14.4 5.26914V1.75H1.8V7.875H9.54C9.19406 8.53125 9 9.275 9 10.0625C9 11.6895 9.8325 13.1277 11.1037 14H4.5C4.00219 14 3.6 13.609 3.6 13.125C3.6 12.641 4.00219 12.25 4.5 12.25H6.44906L6.75 11.375H1.8C0.807187 11.375 0 10.5902 0 9.625V1.75ZM9.9 10.0625C9.9 8.65703 10.6706 7.35547 11.925 6.65273C13.1794 5.95 14.7206 5.95 15.975 6.65273C17.2294 7.35547 18 8.65703 18 10.0625C18 11.468 17.2294 12.7695 15.975 13.4723C14.7206 14.175 13.1794 14.175 11.925 13.4723C10.6706 12.7695 9.9 11.468 9.9 10.0625ZM12.6 8.75V11.375C12.6 11.5336 12.6872 11.6785 12.8278 11.7551C12.9684 11.8316 13.1428 11.8316 13.2806 11.7496L15.5306 10.4371C15.6656 10.3578 15.75 10.2156 15.75 10.0625C15.75 9.90938 15.6684 9.76719 15.5306 9.68789L13.2806 8.37539C13.1428 8.29336 12.9684 8.29336 12.8278 8.36992C12.6872 8.44648 12.6 8.59414 12.6 8.75Z" fill="#FAAF42"/>
                                                                    </svg>
                                                                    <span className="label">Tutorials</span>
                                                                </Link>
                                                            </li>
                                                        :
                                                            <></>
                                                    }
                                                    <li>
                                                        <Link href={"https://sendlinx.com/support-help-faq/"} target="_blank" className={"support-link"}>
                                                            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M4.54999 7.7C7.06343 7.7 9.1 5.97625 9.1 3.85C9.1 1.72375 7.06343 0 4.54999 0C2.03656 0 -4.73091e-06 1.72375 -4.73091e-06 3.85C-4.73091e-06 4.69438 0.321558 5.47531 0.866245 6.11187C0.789683 6.3175 0.675933 6.49906 0.55562 6.65219C0.45062 6.78781 0.343433 6.89281 0.264683 6.965C0.225308 7 0.192495 7.02844 0.17062 7.04594C0.159683 7.05469 0.150933 7.06125 0.146558 7.06344L0.142183 7.06781C0.0218703 7.1575 -0.0306297 7.315 0.0174953 7.45719C0.0656203 7.59937 0.199058 7.7 0.349995 7.7C0.82687 7.7 1.30812 7.5775 1.70843 7.42656C1.90968 7.35 2.09781 7.26469 2.25968 7.17719C2.93343 7.50969 3.71437 7.7 4.54999 7.7ZM9.8 3.85C9.8 6.30656 7.63218 8.15719 5.06406 8.37813C5.59562 10.0056 7.35875 11.2 9.45 11.2C10.2856 11.2 11.0666 11.0097 11.7403 10.6772C11.9044 10.7647 12.0903 10.85 12.2916 10.9266C12.6919 11.0775 13.1731 11.2 13.65 11.2C13.8009 11.2 13.9366 11.1016 13.9825 10.9572C14.0284 10.8128 13.9781 10.6553 13.8556 10.5656L13.8512 10.5612C13.8469 10.5569 13.8381 10.5525 13.8272 10.5437C13.8053 10.5262 13.7725 10.5 13.7331 10.4628C13.6544 10.3906 13.5472 10.2856 13.4422 10.15C13.3219 9.99687 13.2081 9.81312 13.1316 9.60969C13.6762 8.97531 13.9978 8.19438 13.9978 7.34781C13.9978 5.31781 12.1406 3.65312 9.78468 3.50875C9.79343 3.62031 9.79781 3.73406 9.79781 3.84781L9.8 3.85ZM3.94187 1.69094H5.00281C5.63937 1.69094 6.15343 2.20719 6.15343 2.84156C6.15343 3.25281 5.9325 3.63562 5.57593 3.83906L4.98749 4.17812C4.98312 4.41656 4.78843 4.60687 4.54999 4.60687C4.30937 4.60687 4.11249 4.41 4.11249 4.16937V3.92437C4.11249 3.76687 4.19562 3.6225 4.33124 3.54594L5.14062 3.08219C5.22593 3.03187 5.27843 2.94219 5.27843 2.84375C5.27843 2.69062 5.15375 2.56813 5.00281 2.56813H3.94187C3.88062 2.56813 3.82593 2.6075 3.80406 2.66438L3.79531 2.68625C3.71437 2.91375 3.465 3.03406 3.2375 2.95312C3.01 2.87219 2.88968 2.62281 2.97062 2.39531L2.97937 2.37344C3.12374 1.96656 3.50874 1.69313 3.94187 1.69313V1.69094ZM4.54999 5.19094C4.62956 5.18606 4.70927 5.19752 4.78424 5.22461C4.8592 5.25171 4.92782 5.29386 4.98589 5.34847C5.04395 5.40308 5.09022 5.469 5.12184 5.54216C5.15347 5.61533 5.16979 5.6942 5.16979 5.77391C5.16979 5.85362 5.15347 5.93248 5.12184 6.00565C5.09022 6.07881 5.04395 6.14473 4.98589 6.19934C4.92782 6.25396 4.8592 6.29611 4.78424 6.3232C4.70927 6.35029 4.62956 6.36175 4.54999 6.35687C4.47044 6.36175 4.39072 6.35029 4.31575 6.3232C4.24079 6.29611 4.17217 6.25396 4.1141 6.19934C4.05604 6.14473 4.00977 6.07881 3.97815 6.00565C3.94652 5.93248 3.93021 5.85362 3.93021 5.77391C3.93021 5.6942 3.94652 5.61533 3.97815 5.54216C4.00977 5.469 4.05604 5.40308 4.1141 5.34847C4.17217 5.29386 4.24079 5.25171 4.31575 5.22461C4.39072 5.19752 4.47044 5.18606 4.54999 5.19094ZM12.3834 7.13344L10.6334 8.88344C10.4628 9.05406 10.185 9.05406 10.0144 8.88344L9.13937 8.00844C8.96875 7.83781 8.96875 7.56 9.13937 7.38937C9.30999 7.21875 9.58781 7.21875 9.75843 7.38937L10.325 7.95594L11.7666 6.51437C11.9372 6.34375 12.215 6.34375 12.3856 6.51437C12.5562 6.685 12.5562 6.96281 12.3856 7.13344H12.3834Z" fill="#FAAF42"/>
                                                            </svg>
                                                            <span className="label">FAQ</span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Popover>
                                    </>
                                    {
                                        user.level_id !== 5 && Config.isLimitedAccess() === false && user.settings.recentUpdatesMenuUrl !== '' ?
                                            <div className={classes.updatesIcon} title="Recent Updates">
                                                <Link href={user.settings.recentUpdatesMenuUrl} target="_blank">
                                                    <svg width="19" height="22" viewBox="0 0 19 22" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.82143 0.6875C8.82143 0.309375 9.12679 0 9.5 0C9.87321 0 10.1786 0.309375 10.1786 0.6875V1.40937C13.6096 1.75312 16.2857 4.68359 16.2857 8.25V9.50039C16.2857 11.3781 17.0237 13.1785 18.3342 14.5105L18.4529 14.6309C18.8049 14.9875 19.0042 15.473 19.0042 15.9758C19.0042 17.0285 18.1645 17.8793 17.1254 17.8793H1.87879C0.839732 17.875 0 17.0242 0 15.9715C0 15.4688 0.19933 14.9832 0.551339 14.6266L0.670089 14.5063C1.97634 13.1785 2.71429 11.3781 2.71429 9.50039V8.25C2.71429 4.68359 5.3904 1.75312 8.82143 1.40937V0.6875ZM9.5 2.75C6.50156 2.75 4.07143 5.21211 4.07143 8.25V9.50039C4.07143 11.7434 3.19353 13.8961 1.62433 15.4816L1.50982 15.5977C1.41228 15.6965 1.35714 15.8297 1.35714 15.9715C1.35714 16.2637 1.5904 16.5 1.87879 16.5H17.1212C17.4096 16.5 17.6429 16.2637 17.6429 15.9715C17.6429 15.8297 17.5877 15.6965 17.4902 15.5977L17.3714 15.4773C15.8065 13.8918 14.9243 11.7391 14.9243 9.49609V8.25C14.9243 5.21211 12.4942 2.75 9.49576 2.75H9.5ZM8.2192 19.7098C8.4058 20.2426 8.91049 20.625 9.5 20.625C10.0895 20.625 10.5942 20.2426 10.7808 19.7098C10.9038 19.3531 11.294 19.1641 11.646 19.2887C11.998 19.4133 12.1846 19.8086 12.0616 20.1652C11.6884 21.2352 10.6833 22 9.5 22C8.31674 22 7.31161 21.2352 6.93839 20.1652C6.8154 19.8086 6.99777 19.4133 7.35402 19.2887C7.71027 19.1641 8.09621 19.3488 8.2192 19.7098Z"/>
                                                    </svg>
                                                </Link>
                                            </div>
                                        :
                                            <></>
                                    }
                                    <IconButton
                                        className={classes.userFirstLetter}
                                        color="inherit"
                                        aria-label="open popup"
                                        // onClick={this.handlePopup}
                                        variant="contained"
                                        onClick={this.handleClick}
                                        aria-describedby={id}
                                    >
                                        <span className="user-icon">
                                            {
                                                user.icon_photo_url ?
                                                    <img src={user.icon_photo_url} className="profile-picture" alt={userFirstLetter} />
                                                :
                                                    userFirstLetter
                                            }
                                        </span>
                                    </IconButton>
                                    <Popover
                                        id={id}
                                        open={popupOpen}
                                        anchorEl={anchorEl}
                                        onClose={this.handleClose}
                                        keepMounted
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 40,
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        classes={{
                                            root: classes.popoverRoot
                                        }}
                                    >
                                        <div className={classes.popupContent}>
                                            <div className={"top-content"}>
                                                <div className={classes.userFirstLetter+" user-image"}>
                                                    <RouerLink to={"/user/profile"} onClick={this.handleClose}>
                                                        <span className="user-icon">
                                                            {
                                                                uploading === true ?
                                                                    <LoaderComponent color="custom" align="center" />
                                                                : success === true || user.icon_photo_url ?
                                                                    <img className={"profile-picture"} src={user.icon_photo_url} alt={userFirstLetter} />
                                                                : 
                                                                    userFirstLetter   
                                                            }
                                                        </span>
                                                    </RouerLink>
                                                    {/* <IconButton><CameraIcon/></IconButton> */}
                                                    <div className="uploadPhotoInput">
                                                        <CustomFileInput
                                                            id="input-photo"                            
                                                            onChange={(e) => this.handleFileChange(e,'photo')}
                                                            endButton={{
                                                                buttonProps: {
                                                                    round: true,
                                                                    color: "custom",
                                                                    justIcon: true,
                                                                    fileButton: true
                                                                },
                                                                icon: <CameraIcon />
                                                            }}
                                                            inputProps={{
                                                                value: photo,
                                                                placeholder: "Photo"
                                                            }}
                                                            color="custom"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                            }}
                                                            accept="image/*"
                                                        />
                                                    </div>
                                                    {
                                                        success === true || user.icon_photo_url ?
                                                            <div className={"removePhoto"}>
                                                                <Button color="custom" justIcon={true} round={true} size={"sm"} onClick={(e) => this.removeProfilePhoto(e, 'photo')}><DeleteIcon /></Button>
                                                            </div>
                                                        :
                                                            <></>
                                                    }
                                                </div>
                                                <h4 className="user-name">{this.getUserTitle(user)}</h4>
                                                <p className="user-email">{user.email}</p>
                                                {
                                                    Config.isLimitedAccess() === false ?
                                                        <RouerLink to={"/user/account"} onClick={this.handleClose}>
                                                            <Button className={"user-manage"} color="purewhite">Account Management</Button>
                                                        </RouerLink>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    user.dismiss_recovery_section ?
                                                        <></>
                                                    : (!user.recovery_email && !user.recovery_phone) ?
                                                        <div className="recovery-section">
                                                            <div className="recovery-text">
                                                                <div>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" fill="#F09D00"></circle><path d="M11 15H13V17H11V15ZM11 7H13V13H11V7Z" fill="#1F1F1F" className="QLnTJd"></path></svg>
                                                                </div>
                                                                <div>
                                                                    <p className="bold">You could lose access to Sendlinx</p>
                                                                    <p>A recovery phone or email will help if you forget your email or password</p>
                                                                </div>
                                                            </div>
                                                            <div className="recovery-buttons">
                                                                <Button color="white" onClick={() => this.dismissRecoveryOption()}>Dismiss</Button>
                                                                <RouerLink to={"/user/account/recovery"} onClick={this.handleClose}>
                                                                    <Button color="custom">Add Recovery Option</Button>
                                                                </RouerLink>
                                                            </div>
                                                        </div>
                                                    :
                                                        <></>
                                                }                                            
                                                {
                                                    user.level_id !== 5 ?
                                                        <div className="stats-section">
                                                            <div className="left-stats">
                                                                <div className="graph-stats">
                                                                    <ChartistGraph
                                                                        data={pieChart.data}
                                                                        type="Pie"
                                                                        options={pieChart.options}
                                                                    />
                                                                </div>
                                                                <div className="data-detail">
                                                                    <span className="used-data">{helper.getFormatedSize(user.usage)}</span>
                                                                    <span className="remaining-data">{helper.getFormatedSize(user.quota)}</span>
                                                                </div>
                                                            </div>
                                                            <div className="right-stats">
                                                                <ul>
                                                                    {this.renderStats()}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    :
                                                        <></>
                                                }
                                                <div className="signup-btn">
                                                    <RouerLink to={"/auth/logout"} onClick={this.handleClose}>
                                                        <Button className={"user-manage"} color="purewhite">Sign out</Button>
                                                    </RouerLink>
                                                </div>
                                            </div>
                                            <div className="bottom-content">
                                                <ul>
                                                    <li><Link href="https://sendlinx.com/privacy-policy/" target="_blank" onClick={this.handleClose}>Privacy Policy</Link></li>
                                                    <li><Link href="https://sendlinx.com/terms-of-use/" target="_blank" onClick={this.handleClose}>Terms of Use</Link></li>
                                                    <li><RouerLink to={"/agreement/policy"} onClick={this.handleClose}>Agreement Policy</RouerLink></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Popover>
                                </>
                            :
                                <></>
                        }
                        {
                            !authorized || (authorized && user.level_id === 5) ?
                                <Hidden mdUp>
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={this.handleDrawerToggle}
                                        className={classes.toggleIcon}
                                    >
                                        <Menu />
                                    </IconButton>
                                </Hidden>
                            :
                                <></>
                        }
                        <Hidden mdUp implementation="js">
                            <Drawer
                                variant="temporary"
                                anchor={"right"}
                                open={this.state.mobileOpen}
                                classes={{
                                    paper: classes.drawerPaper
                                }}
                                onClose={this.handleDrawerToggle}
                            >
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={this.handleDrawerToggle}
                                    className={classes.closeButtonDrawer}
                                >
                                    <Close />
                                </IconButton>
                                <div className={classes.appResponsive}>{mobileLinks}</div>
                            </Drawer>
                        </Hidden>
                    </div>
                </Toolbar>
                {
                    firstTimeLoginModal ?
                        <FirstTimeLoginModal
                            store={this.store}
                            open={firstTimeLoginModal}
                            onClose={() => this.onFirstTimeLoginModal(false)}
                            firstTimeloginData={firstTimeloginData}
                        />
                    :
                        <></>
                }
                {
                    subscriptionModal ?
                        <ConfirmationModal 
                            open={subscriptionModal} 
                            onClose={() => this.onSubscriptionModal(false)} 
                            onSuccess={() => this.subscriptionTrialEnd()}
                            confirmationMessage="Are you sure you want to activate your account now? Activating will end your trial immediately, process your credit card payment via Chargebee, and upgrade your account."
                            successMessage={"Activation Successful"}
                            cancelButtonText={"Cancel"}
                            successButtonText={"Activate"}
                            saving={activateSaving}
                            success={subscriptionUserData === null ? false : true}
                            showError={showSubscriptionError}
                            errorMessage={errorMessage}

                        />
                    :
                        <></>
                }
            </AppBar>
        );
    }
}

Header.defaultProp = {
  color: "white",
  open: false,
  updateDrawer: function(){ },
  desktop: false
};

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark"
    ]),
    links: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    open: PropTypes.bool,
    updateDrawer: PropTypes.func,
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark"
        ]).isRequired
    }),
    desktop: PropTypes.bool
};

export default withStyles(headerStyle)(Header);
